<template>
    <Cmember :curnavkv="curnavkv" :navsub.sync="navsub" :options="c_options" @optionchange="optionchange" @groupupdate="groupup">
        <template v-if="isload && navsub==0">
            <div class="memcourse" v-for="item in infolist" :key="item.id" v-if="$common.basic.isarrayexist(item.x_children)">
                <div class="title" v-html="item.title"></div>
                <div class="list">
                    <dl v-for="item2 in item.x_children" :key="item2.id">
                        <dt><fflink linktype="image" :info="item2"></fflink></dt>
                        <dd class="a"><fflink :info="item2" :forceurl="item2.x_url2"></fflink></dd>
                        <dd class="b">
                            <span class="b1">{{$common.dicword('tokprogress')}}</span>
                            <span class="b2wrap">
                                <span class="b2"><span class="b2now" :style="{width:item2.x_perc+'%'}"></span></span>
                                <span class="b3">{{item2.x_perc}}%</span>
                            </span>

                        </dd>
                    </dl>
                    <dl class="placeholder"></dl><dl class="placeholder"></dl><dl class="placeholder"></dl>
                </div>
            </div>
            <div class="memnorecord" v-if="infolist.length==0">{{$common.dicword('norecord')}}</div>
        </template>
        <Cschedule :navsub="navsub" :options="c_myoption" v-if="isload && navsub>=1" :grouplist="grouplist"></Cschedule>
    </Cmember>
</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'member',
        mixins: [mixinmember],
        data() {
            return {
                curnavkv: 1
            };
        },
        components: {
            Cschedule: () => import('@/components/Cschedule')
        },
        computed: {
            c_options: function () {
                let _options = {
                    'hasoption': true, 'courselev': 2, 'showcourse': 2, 'hasstat': 0, 'haskw': true, 'noteng': 0, 'hasgroup': 1, 'showschool': false, 'showgroup': false
                };
                if (this.navsub == 11) {
                    _options.showschool = true;
                    _options.showgroup = true;
                }

                return _options;
            },
            c_myoption: function () {
                let _myoption = this.$common.basic.jsonclone(this.myoption);
                switch (this.navsub) {
                    case 1:
                        _myoption.schstat = 1;
                        break;
                    case 2:
                        _myoption.schstat = 3;
                        break;
                    case 3:
                        _myoption.schstat = 2;
                        break;
                    case 11:
                        _myoption.schstat = 0;
                        _myoption.tk = 1;
                        break;
                    case 12:
                        _myoption.schstat = 0;
                        _myoption.tk = 2;
                        break;
                }
                return _myoption;
            }
        },
        methods: {
            getdata: function () {
                if (this.navsub == 0) {
                    let jsondata = { 'postdata': { 'act': 'tc_my_course', 'data': this.c_myoption } };
                    this.$common.post(jsondata, res => {
                        this.isload = true;

                        this.$common.each(res.infodata, (item) => {

                            item.x_children = res.infodatacourse.filter(item2 => item2.levelid == item.id);

                            this.$common.each(item.x_children, (item2) => {
                                let courseroot = this.$common.tranlearnfolder(item2.realtypekv);
                                item2.x_url = courseroot + item2.id;
                                item2.x_url2 = courseroot + item2.id;
                                item2.x_len = 20;
                                item2.x_perc = 0;
                                let pro = this.$common.basic.fffind(res.infodataprogress, 'courseid', item2.realid);
                                if (this.$common.basic.isobjexist(pro)) {
                                    item2.x_perc = Math.round(pro.perc);
                                    item2.x_url = courseroot + 'continue/' + item2.id;
                                }
                            });

                        });
                        this.infolist = res.infodata;

                    });
                }
                else {
                    this.isload = true;
                }
            }
        }
    }
</script>
